module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid64_980x845.7c06b58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid64_980x845.jpg
// module id = jKbL
// module chunks = 0